<template>
	<Row class="stt-on-youtube">
		<Container>
			<div
				class="title-container"
				id="youtube-section-title"
				data-animate="true"
			>
				<h2 class="title">StocksToTrade on YouTube</h2>
				<NuxtLink
					class="subscribe-to"
					to="https://www.youtube.com/@Stockstotrade"
					target="_blank"
				>
					<svg
						width="48"
						height="48"
						viewBox="0 0 48 48"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							width="48"
							height="48"
							rx="24"
							fill="#FF3737"
						/>
						<path
							d="M23.9996 15.2C20.6508 15.2 16.3043 16.039 16.3043 16.039L16.2934 16.0515C14.7681 16.2954 13.5996 17.6061 13.5996 19.2V24V24.0015V28.8V28.8015C13.6011 29.5627 13.8739 30.2985 14.369 30.8767C14.8642 31.4549 15.5492 31.8376 16.3012 31.9562L16.3043 31.9609C16.3043 31.9609 20.6508 32.8015 23.9996 32.8015C27.3484 32.8015 31.6949 31.9609 31.6949 31.9609L31.6965 31.9593C32.4492 31.841 33.1351 31.458 33.6306 30.8791C34.1261 30.3002 34.3988 29.5635 34.3996 28.8015V28.8V24.0015V24V19.2C34.3985 18.4385 34.1259 17.7023 33.6307 17.1238C33.1355 16.5453 32.4503 16.1623 31.698 16.0437L31.6949 16.039C31.6949 16.039 27.3484 15.2 23.9996 15.2ZM21.5996 20.3187L27.9996 24L21.5996 27.6812V20.3187Z"
							fill="white"
						/>
					</svg>
					Subscribe to our channel
				</NuxtLink>
			</div>
			<div class="youtube-thumbnails mb-[24px] lg:mb-[48px]">
				<div class="big-image">
					<NuxtLink
						class="youtube-item"
						to="https://www.youtube.com/watch?v=Ka638b5p3C0&"
						target="_blank"
					>
						<img
							src="/images/big-thumb-youtube-section.webp"
							class="big-thumbnail"
							width="717"
							height="504"
							alt="yt-image-1"
						/>
						<div class="content-container big-image-content">
							<span class="content-title">
								The Best Stock Screeners for New Day Traders
							</span>
							<div class="clock-container">
								<img
									class="white-clock"
									src="/images/clock.svg"
									width="24px"
									height="24px"
									alt="clock-image"
								/>
								<span class="clock-time">11 min</span>
							</div>
						</div>
					</NuxtLink>
				</div>
				<div class="small-image">
					<div class="small-image-container">
						<NuxtLink
							class="youtube-item"
							to="https://www.youtube.com/watch?v=y3pJarOEe_k"
							target="_blank"
						>
							<div class="image-container">
								<img
									src="/images/small-thumb-1-risk.webp"
									width="197"
									height="152"
									class="small-thumbnail"
									alt="yt-image-2"
								/>
							</div>
							<div class="content-container">
								<span class="content-title">
									Mastering Risk Management: The Key to Sustainable Trading Success
								</span>
								<div class="clock-container">
									<img
										src="/images/clock.svg"
										class="grey-clock"
										width="24px"
										height="24px"
										alt="clock-image"
									/>
									<span class="clock-time">13 min</span>
								</div>
							</div>
						</NuxtLink>
					</div>
					<div class="small-image-container">
						<NuxtLink
							class="youtube-item"
							to="https://www.youtube.com/watch?v=bGUuv7ogVFQ"
							target="_blank"
						>
							<div class="image-container">
								<img
									src="/images/small-thumb-1-predict.webp"
									width="197"
									height="152"
									alt="yt-image-2"
								/>
							</div>
							<div class="content-container">
								<span class="content-title">
									The #1 Tool To Use To Predict Stocks to Buy
								</span>
								<div class="clock-container">
									<img
										src="/images/clock.svg"
										class="grey-clock"
										width="24px"
										height="24px"
										alt="clock-image"
									/>
									<span class="clock-time">11 min</span>
								</div>
							</div>
						</NuxtLink>
					</div>
					<div class="small-image-container">
						<NuxtLink
							class="youtube-item"
							to="https://www.youtube.com/watch?v=F7jJJBI6pR8"
							target="_blank"
						>
							<div class="image-container">
								<img
									src="/images/small-thumb-1-best.webp"
									width="197"
									height="152"
									alt="yt-image-2"
									loading="lazy"
								/>
							</div>
							<div class="content-container">
								<span class="content-title">
									Day Trading 101, Episode 1: Day Trading for Beginners
								</span>
								<div class="clock-container">
									<img
										src="/images/clock.svg"
										class="grey-clock"
										width="24px"
										height="24px"
										alt="clock-image"
										loading="lazy"
									/>
									<span class="clock-time">10 min</span>
								</div>
							</div>
						</NuxtLink>
					</div>
				</div>
			</div>
			<NuxtLink
				class="subscribe-to-mobile"
				to="https://www.youtube.com/@Stockstotrade"
				target="_blank"
			>
				Subscribe to our channel
			</NuxtLink>
			<div class="stats-container">
				<div class="stats-item">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="40"
						height="40"
						viewBox="0 0 40 40"
						fill="none"
					>
						<rect
							width="40"
							height="40"
							rx="20"
							fill="url(#paint0_linear_2873_1451)"
						/>
						<path
							d="M31.7223 10.9755C31.4914 10.9824 31.2722 11.0789 31.1112 11.2446L27.5173 16.2573L25.4791 14.2191C25.3124 14.0525 25.0864 13.9589 24.8507 13.9589C24.615 13.9589 24.3889 14.0525 24.2222 14.2191L21.2951 17.1462L19.2569 16.5175C19.0902 16.3509 18.6285 16.2573 18.6285 16.2573C18.6285 16.2573 18.1667 16.3509 18 16.5175L14.2732 23.0127C14.1879 23.0947 14.1198 23.1928 14.0729 23.3013C14.026 23.4099 14.0012 23.5267 14 23.645C13.9988 23.7632 14.0212 23.8805 14.0659 23.99C14.1106 24.0995 14.1767 24.199 14.2603 24.2826C14.344 24.3662 14.4434 24.4323 14.5529 24.477C14.6624 24.5217 14.7797 24.5441 14.898 24.5429C15.0162 24.5417 15.1331 24.5169 15.2416 24.47C15.3502 24.4231 15.4483 24.355 15.5302 24.2697L19 18.5429L20.6667 19.0316C20.8334 19.1982 21.0594 19.2918 21.2951 19.2918C21.5308 19.2918 21.7569 19.1982 21.9236 19.0316L24.8507 16.1045L26.8888 18.1427C27.0555 18.3093 27.2816 18.403 27.5173 18.403C27.753 18.403 27.9791 18.3093 28.1458 18.1427L32.3681 12.5015C32.4966 12.3767 32.5843 12.2159 32.6198 12.0403C32.6553 11.8648 32.637 11.6826 32.5672 11.5176C32.4974 11.3526 32.3793 11.2126 32.2286 11.1159C32.0778 11.0191 31.9013 10.9702 31.7223 10.9755ZM8.90154 27.2474C8.78376 27.2458 8.66681 27.2675 8.55751 27.3115C8.4482 27.3554 8.34872 27.4206 8.26483 27.5033C8.18095 27.586 8.11434 27.6846 8.06888 27.7932C8.02341 27.9019 8 28.0185 8 28.1363C8 28.2541 8.02341 28.3708 8.06888 28.4794C8.11434 28.5881 8.18095 28.6867 8.26483 28.7694C8.34872 28.8521 8.4482 28.9173 8.55751 28.9612C8.66681 29.0051 8.78376 29.0269 8.90154 29.0252L31.7183 28.9813C31.8361 28.983 31.953 28.9612 32.0623 28.9173C32.1716 28.8734 32.2711 28.8081 32.355 28.7254C32.4389 28.6427 32.5055 28.5442 32.5509 28.4355C32.5964 28.3268 32.6198 28.2102 32.6198 28.0924C32.6198 27.9746 32.5964 27.858 32.5509 27.7493C32.5055 27.6406 32.4389 27.5421 32.355 27.4594C32.2711 27.3767 32.1716 27.3115 32.0623 27.2675C31.953 27.2236 31.8361 27.2019 31.7183 27.2035L8.90154 27.2474Z"
							fill="white"
						/>
						<path
							d="M10 10C9.46957 10 8.96086 10.2107 8.58579 10.5858C8.21071 10.9609 8 11.4696 8 12C8 12.5304 8.21071 13.0391 8.58579 13.4142C8.96086 13.7893 9.46957 14 10 14C10.5304 14 11.0391 13.7893 11.4142 13.4142C11.7893 13.0391 12 12.5304 12 12C12 11.4696 11.7893 10.9609 11.4142 10.5858C11.0391 10.2107 10.5304 10 10 10ZM15.987 13.9948C15.8593 13.9989 15.7354 14.0395 15.6302 14.112L13.7982 15.3333H13.3333H9.33333C8.59667 15.3333 8 15.93 8 16.6667V25.3112C8 25.6912 8.3088 26 8.6888 26C9.05147 26 9.3523 25.7181 9.3763 25.3568L9.66797 20.9779C9.67997 20.8032 9.82467 20.6667 10 20.6667C10.1753 20.6667 10.32 20.8026 10.332 20.9766L10.6237 25.3568C10.6477 25.7188 10.9485 26 11.3112 26C11.6912 26 12 25.6912 12 25.3112V17.3333C12 16.9653 12.2987 16.6667 12.6667 16.6667H14C14.1316 16.6667 14.2603 16.6277 14.3698 16.5547L16.3698 15.2214C16.4923 15.1423 16.5854 15.0253 16.6351 14.8883C16.6847 14.7512 16.6881 14.6017 16.6447 14.4625C16.6012 14.3234 16.5134 14.2023 16.3946 14.1179C16.2759 14.0334 16.1327 13.9902 15.987 13.9948Z"
							fill="white"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_2873_1451"
								x1="-0.000702253"
								y1="20"
								x2="39.9812"
								y2="20"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#50B5FF" />
								<stop
									offset="1"
									stop-color="#BE55FF"
								/>
							</linearGradient>
						</defs>
					</svg>
					<span class="highlight">3+</span>
					New Lessons Weekly
				</div>
				<div class="stats-item">
					<svg
						width="40"
						height="40"
						viewBox="0 0 40 40"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							width="40"
							height="40"
							rx="20"
							fill="url(#paint0_linear_2873_1458)"
						/>
						<path
							d="M20 12C12.5681 12 7.76749 19.3689 7.68066 19.5031C7.56379 19.6445 7.50013 19.8196 7.5 20C7.50015 20.1548 7.54707 20.3062 7.63509 20.4359C7.63617 20.4375 7.63726 20.4391 7.63835 20.4406C7.65267 20.469 11.6824 28 20 28C28.2824 28 32.3061 20.543 32.3551 20.4516C32.3585 20.4464 32.3617 20.4412 32.3649 20.4359C32.4529 20.3062 32.4999 20.1548 32.5 20C32.5 19.8203 32.4369 19.6458 32.321 19.5047C32.3204 19.5042 32.3199 19.5036 32.3193 19.5031C32.2325 19.3689 27.4319 12 20 12ZM20 14.4C23.2217 14.4 25.8333 16.9072 25.8333 20C25.8333 23.0928 23.2217 25.6 20 25.6C16.7783 25.6 14.1667 23.0928 14.1667 20C14.1667 16.9072 16.7783 14.4 20 14.4ZM20 17.6C19.337 17.6 18.7011 17.8529 18.2322 18.3029C17.7634 18.753 17.5 19.3635 17.5 20C17.5 20.6365 17.7634 21.247 18.2322 21.6971C18.7011 22.1471 19.337 22.4 20 22.4C20.663 22.4 21.2989 22.1471 21.7678 21.6971C22.2366 21.247 22.5 20.6365 22.5 20C22.5 19.3635 22.2366 18.753 21.7678 18.3029C21.2989 17.8529 20.663 17.6 20 17.6Z"
							fill="white"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_2873_1458"
								x1="-0.000702253"
								y1="20"
								x2="39.9812"
								y2="20"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#50B5FF" />
								<stop
									offset="1"
									stop-color="#BE55FF"
								/>
							</linearGradient>
						</defs>
					</svg>
					<span class="highlight">37M+</span>
					views
				</div>
				<div class="stats-item">
					<svg
						width="40"
						height="40"
						viewBox="0 0 40 40"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							width="40"
							height="40"
							rx="20"
							fill="url(#paint0_linear_2873_1464)"
						/>
						<path
							d="M30.2133 25.28C30 26.4 29.0933 27.2533 27.9733 27.4133C26.2133 27.68 23.28 28 19.9733 28C16.72 28 13.7866 27.68 11.9733 27.4133C10.8533 27.2533 9.94664 26.4 9.73331 25.28C9.51997 24.0533 9.30664 22.24 9.30664 20C9.30664 17.76 9.51997 15.9467 9.73331 14.72C9.94664 13.6 10.8533 12.7467 11.9733 12.5867C13.7333 12.32 16.6666 12 19.9733 12C23.28 12 26.16 12.32 27.9733 12.5867C29.0933 12.7467 30 13.6 30.2133 14.72C30.4266 15.9467 30.6933 17.76 30.6933 20C30.64 22.24 30.4266 24.0533 30.2133 25.28Z"
							fill="white"
						/>
						<path
							d="M17.8398 23.7333V16.2666L24.2398 19.9999L17.8398 23.7333Z"
							fill="url(#paint1_linear_2873_1464)"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_2873_1464"
								x1="-0.000702253"
								y1="20"
								x2="39.9812"
								y2="20"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#50B5FF" />
								<stop
									offset="1"
									stop-color="#BE55FF"
								/>
							</linearGradient>
							<linearGradient
								id="paint1_linear_2873_1464"
								x1="17.8397"
								y1="19.9999"
								x2="24.2368"
								y2="19.9999"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#50B5FF" />
								<stop
									offset="1"
									stop-color="#BE55FF"
								/>
							</linearGradient>
						</defs>
					</svg>
					<span class="highlight">2K+</span>
					videos
				</div>
				<div class="stats-item">
					<svg
						width="40"
						height="40"
						viewBox="0 0 40 40"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							width="40"
							height="40"
							rx="20"
							fill="url(#paint0_linear_2873_1473)"
						/>
						<path
							d="M18.7996 12V13.7563C16.7302 14.2897 15.1996 16.1638 15.1996 18.4V23.2L13.5996 24.8V25.6H26.3996V24.8L24.7996 23.2V18.4C24.7996 16.1638 23.2691 14.2897 21.1996 13.7563V12H18.7996ZM18.3996 26.4C18.3996 27.28 19.1196 28 19.9996 28C20.8796 28 21.5996 27.28 21.5996 26.4H18.3996Z"
							fill="white"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_2873_1473"
								x1="-0.000702253"
								y1="20"
								x2="39.9812"
								y2="20"
								gradientUnits="userSpaceOnUse"
							>
								<stop stop-color="#50B5FF" />
								<stop
									offset="1"
									stop-color="#BE55FF"
								/>
							</linearGradient>
						</defs>
					</svg>
					<span class="highlight">113K+</span>
					subscribers
				</div>
			</div>
		</Container>
	</Row>
</template>

<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;

.stt-on-youtube {
	background: var(
		--gradient,
		linear-gradient(
			73deg,
			rgba(0, 87, 255, 0.2) 4.01%,
			rgba(222, 89, 255, 0.2) 81.74%
		)
	);

	.subscribe-to {
		display: none;
	}

	@include breakpoint(lg) {
		.subscribe-to {
			display: inline-flex;
		}
		.subscribe-to-mobile {
			display: none;
		}
	}
}

.title-container {
	padding-bottom: 32px;
	@include breakpoint(lg) {
		padding-bottom: 72px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}
.title {
	color: #fff;
	font-feature-settings:
		"clig" off,
		"liga" off;
	font-family: Open Sauce Sans;
	font-size: 36px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%; /* 67.2px */
	letter-spacing: -2px;
	text-align: center;

	@include breakpoint(lg) {
		font-size: 56px;
		text-align: start;
	}
}

.subscribe-to,
.subscribe-to-mobile {
	background-color: #fff;
	color: #4383ff;
	font-size: 18px;
	display: inline-flex;
	font-family: DM Sans;
	text-align: center;
	color: #0a0e1d;
	font-style: normal;
	font-weight: 700;
	line-height: 26px;
	padding: 8px 16px;
	border-radius: 24px;
	align-items: center;

	svg {
		margin-right: 12px;
	}
	&::after {
		content: "";
		display: inline-block;
		width: 28px;
		height: 28px;
		background-image: url("/images/arrow-right-black.svg");
		background-repeat: no-repeat;
		background-size: 18px;
		background-position: center;
		border-radius: 50%;
		margin-left: 8px;
		vertical-align: middle;
	}

	&:hover {
		color: #4383ff;
	}
}

.subscribe-to-mobile {
	display: flex;
	justify-content: center;
	margin-bottom: 16px;
}

.youtube-thumbnails {
	display: grid;
	gap: 24px;
	line-height: 0;

	@include breakpoint(lg) {
		grid-template-columns: 3fr 2fr;
	}

	img {
		border-radius: 16px;
	}
}

.big-image {
	flex-shrink: 0;
	overflow: hidden;
	max-height: 504px;
	.youtube-item {
		text-decoration: none;
		display: block;
		position: relative;

		@include breakpoint(lg) {
			.big-image-content {
				position: absolute;
				bottom: 0;
				left: 0;
				z-index: 2;
				width: 100%;
				text-align: start;
				max-height: 504px;

				.content-title {
					font-size: 20px;
				}

				.clock-time {
					font-family: DM Sans;
					font-size: 14px;
					font-style: normal;
					font-weight: 400;
					line-height: 22px;
				}
			}
		}
		&::before {
			display: none;

			@include breakpoint(lg) {
				display: block;
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: rgba(36, 36, 36, 0.6);
				border-radius: 16px;
				z-index: 1;
			}
		}

		&::after {
			content: "";
			position: absolute;
			top: 35%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 96px;
			height: 96px;
			background: url("/images/play-button.svg") no-repeat center center;
			background-size: contain;
			z-index: 2;
			transition: transform 0.3s ease;

			@include breakpoint(lg) {
				top: 50%;
				width: 72px;
				height: 72px;
			}
		}

		&:hover::after {
			transform: translate(-50%, -50%) scale(1.5);
		}
	}

	.big-thumbnail {
		width: 100%;
		height: auto;
		top: -0.21px;
		object-fit: cover;
		display: block;
		max-height: 504px;

		@include breakpoint(lg) {
			width: 100%;
			height: 504px;
		}
	}
}

.youtube-item:first-child {
	grid-column: span 2;
	grid-row: span 3;
}

.small-image-container {
	align-items: center;

	.youtube-item {
		display: flow;
		.image-container {
			position: relative;

			&::before {
				display: none;

				@include breakpoint(lg) {
					display: block;
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background-color: rgba(36, 36, 36, 0.6);
					border-radius: 16px;
					z-index: 1;
				}
			}

			&::after {
				content: "";
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 96px;
				height: 96px;
				background: url("/images/play-button.svg") no-repeat center center;
				background-size: contain;
				z-index: 2;
				transition: transform 0.3s ease;

				@include breakpoint(lg) {
					width: 72px;
					height: 72px;
				}
			}
			&:hover::after {
				transform: translate(-50%, -50%) scale(1.5);
			}

			img {
				width: 100%;
				height: auto;
				object-fit: cover;
				display: block;

				@include breakpoint(lg) {
					width: 197px;
					height: 150px;
				}
			}
		}

		@include breakpoint(lg) {
			display: flex;
		}
	}
}

.content-container {
	display: flex;
	padding-top: 16px;
	flex-direction: column;
	align-items: flex-start;
	gap: 24px;
	flex: 1 0 0;

	@include breakpoint(lg) {
		padding: 24px;
		padding-right: 0;
	}
}

.content-title {
	color: #fff;
	font-family: DM Sans;
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	align-self: stretch;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.25;
	-webkit-line-clamp: 2;
	&:hover {
		color: #4383ff;
	}

	@include breakpoint(lg) {
		font-size: 18px;
	}
}

.clock-container {
	display: flex;
	align-items: center;

	img {
		margin-right: 8px;
		height: 32px;
		width: 32px;

		@include breakpoint(lg) {
			height: 24px;
			width: 24px;
		}
	}

	.clock-time {
		color: #a4acb9;
		/* Body/Small/Regular */
		font-family: DM Sans;
		font-size: 18px;
		font-style: normal;
		font-weight: 400;
		line-height: 22px; /* 157.143% */

		@include breakpoint(lg) {
			font-size: 14px;
		}
	}
}

.stats-container {
	display: contents;
	margin-top: 16px;
	gap: 32px;

	@include breakpoint(lg) {
		display: flex;
		margin-top: 0;
	}

	.stats-item {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		color: #fff;
		font-family: DM Sans;
		font-size: 18px;
		font-style: normal;
		font-weight: 400;
		line-height: 150%;

		svg {
			width: 56px;
			height: 56px;
			margin-right: 8px;
		}

		span {
			color: #fff;
			@include openSauceSans500;
			font-size: 38px;
			font-style: normal;
			font-weight: 700;
			line-height: 120%; /* 45.6px */
			letter-spacing: -0.76px;
			margin-right: 4px;
		}
	}
}

.small-image {
	display: flex;
	flex-direction: column;
	gap: 24px;
}
</style>
